import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { Typography } from "@mui/material";
import axios from "axios";
import { api_base } from "../../../env";
import Cookies from "js-cookie";
import useIsEvent from "../../../service/UseEvent";

function EventCodePage() {
  return <Indexdasbord Children={<EventCode />} />;
}

function EventCode() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEvent, setIsEvent] = useIsEvent();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const queryCode = queryParams.get("code");

  // Handle code from URL (e.g., /EventCodePage?code=XYZ123)
  function CheckCode(code) {
    setLoading(true);
    axios
      .get(`${api_base}event/VerifieCode`, {
        params: { code: code },
      })
      .then((res) => {
        const data = res.data.data;
        Cookies.set("dataEvent", JSON.stringify(data), {
          expires: new Date(data.endDate),
          secure: true,
          sameSite: "strict",
        });
        setIsEvent(true);
        navigate("/event");
      })
      .catch(() => {
        setError("Code invalide depuis le lien. Veuillez réessayer.");
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    if (queryCode) {
      CheckCode(queryCode);
    }
  }, [queryCode, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    CheckCode(code);
  };

  return (
    <div
      style={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f8f8f8",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          padding: 30,
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          width: 350,
        }}
      >
        <Typography style={{ textAlign: "center", marginBottom: 20 }}>
          Entrez le code de l’événement
        </Typography>

        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Ex: ABC123"
          style={{
            width: "100%",
            padding: 10,
            marginBottom: 15,
            fontSize: 16,
          }}
          required
          disabled={loading}
        />

        <button
          type="submit"
          style={{
            padding: 10,
            width: "100%",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: 5,
            fontSize: 16,
            cursor: "pointer",
          }}
          disabled={loading}
        >
          {loading ? "Chargement..." : "Accéder"}
        </button>

        {error && (
          <p style={{ color: "red", marginTop: 15, textAlign: "center" }}>
            {error}
          </p>
        )}
      </form>
    </div>
  );
}

export default EventCodePage;
